const NoMatch = () => {
  return(
    <div>
      NoMatch
    </div>
  );
}

export default NoMatch;